import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function EyeFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.2863 4.25586C12.1912 4.25215 12.0958 4.25 12 4.25L12.2863 4.25586ZM4.40751 7.96086C4.29024 8.07426 4.17608 8.1879 4.06459 8.30078L4.40751 7.96086ZM2.06752 10.6221C2.10486 10.5657 2.14992 10.5027 2.19188 10.4483L2.06752 10.6221ZM2.19188 13.5517C2.31794 13.7152 2.45771 13.892 2.61043 14.0789L2.19188 13.5517ZM4.40751 16.0391C4.51591 16.1439 4.62719 16.2492 4.74127 16.3546L4.40751 16.0391ZM11.714 19.7441C11.8089 19.7478 11.9043 19.75 12 19.75L11.714 19.7441ZM19.2365 16.375C19.3583 16.2628 19.477 16.1507 19.5923 16.0391L19.2365 16.375ZM21.3732 14.0986C21.5323 13.9044 21.6775 13.721 21.808 13.5517L21.3732 14.0986Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0001 8.5C13.9331 8.5001 15.5001 10.0671 15.5001 12C15.5001 13.933 13.9331 15.4999 12.0001 15.5C10.0671 15.5 8.50014 13.933 8.50014 12C8.50014 10.067 10.0671 8.5 12.0001 8.5Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.7296 17.2432C11.8191 17.2477 11.9092 17.25 11.9998 17.25L11.7296 17.2432ZM6.75698 12.2705L6.74983 12C6.74983 12.0907 6.75243 12.1809 6.75698 12.2705ZM17.2498 12C17.2498 12.0863 17.2477 12.1721 17.2436 12.2574L17.2498 12ZM11.9998 6.75C12.0903 6.75 12.1803 6.75231 12.2697 6.75684L11.9998 6.75ZM2.06752 10.6221C1.64722 11.2612 1.52556 12.0185 1.75832 12.7392C1.52461 12.0158 1.6431 11.2628 2.06752 10.6221ZM2.62611 14.0986L2.61043 14.0789C3.04609 14.612 3.58711 15.2275 4.21604 15.8515C3.59476 15.2351 3.05897 14.6272 2.62611 14.0986ZM4.76283 16.375L4.74127 16.3546C5.69806 17.2385 6.85158 18.1272 8.14726 18.7736C6.86131 18.1322 5.71535 17.2522 4.76283 16.375Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0001 19.5C9.22234 19.5 6.74441 17.8585 4.93471 16.1924L4.58119 15.8594C3.88623 15.1873 3.29123 14.5165 2.81947 13.9404L2.38978 13.3994C1.69921 12.5037 1.75258 11.427 2.38978 10.6006L2.81947 10.0596C3.29123 9.48346 3.88623 8.81269 4.58119 8.14062L4.93471 7.80762C6.74441 6.1415 9.22233 4.5 12.0001 4.5C14.9631 4.50008 17.5846 6.36759 19.4181 8.14062L19.758 8.47656C20.5289 9.25711 21.1587 10.0146 21.6105 10.6006L21.7267 10.7646C22.2331 11.5391 22.2304 12.4652 21.7257 13.2363L21.6105 13.3994C21.1587 13.9854 20.5289 14.7429 19.758 15.5234L19.4181 15.8594C17.5846 17.6324 14.9631 19.4999 12.0001 19.5ZM15.4918 15.9204C14.5639 16.7474 13.3406 17.25 11.9998 17.25C11.9092 17.25 11.8191 17.2477 11.7296 17.2432C11.7241 17.2429 11.7185 17.2426 11.7129 17.2423C11.6291 17.2378 11.5458 17.2313 11.463 17.2229C11.2976 17.2061 11.1344 17.1816 10.9738 17.1498C10.7743 17.1103 10.5787 17.0594 10.388 16.9979C8.359 16.3441 6.86958 14.489 6.75698 12.2705C6.75243 12.1809 6.74983 12.0907 6.74983 12C6.74983 9.1005 9.10034 6.75 11.9998 6.75C12.0903 6.75 12.1803 6.75231 12.2697 6.75684C12.9724 6.79241 13.6386 6.96614 14.2418 7.25143C14.4429 7.34652 14.6369 7.45401 14.823 7.5729C15.145 7.77869 15.4431 8.01866 15.7121 8.28769C16.6622 9.23775 17.2498 10.5503 17.2498 12C17.2498 12.0863 17.2477 12.1721 17.2436 12.2574L17.2433 12.2705C17.1697 13.7203 16.5079 15.0148 15.4918 15.9204Z"
				fill="currentColor"
			/>
		</svg>
	);
}

EyeFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default EyeFilledIcon;
